import createUseStyles from '@picsart/rc/create';
import { FontSizes, FontWeights } from '@picsart/rc/fonts';

const use404Styles = createUseStyles(
  {
    root: {
      maxWidth: '1140px',
      marginLeft: 'auto',
      marginRight: 'auto',

      '@media screen and (max-width: 940px)': {
        maxWidth: '700px',
      },
    },

    mainHeader: {
      color: 'var(--texts-negative)',
      fontSize: FontSizes.Size_12,
      lineHeight: '36px',
      fontWeight: FontWeights.Bold,
      textAlign: 'center',
      margin: '0 0 38px 0',
    },
    content: {
      display: 'flex',

      '@media screen and (max-width: 940px)': {
        flexDirection: 'column',
      },
    },
    leftCol: {},
    rightCol: {
      padding: '0 15px',
    },
    number: {
      fontSize: '106px',
      lineHeight: '1',
      padding: '0 40px 0 0',
      color: 'var(--accents-primary-base-active)',

      '@media screen and (max-width: 940px)': {
        textAlign: 'center',
        padding: '0 15px',
        marginBottom: '35px',
      },
    },
    text: {
      fontSize: FontSizes.Size_5,
      lineHeight: '25px',
      color: 'var(--texts-negative)',
      margin: '0 0 26px 0',
    },
    linksWrap: {
      margin: '30px 0',
    },
    linksList: {
      marginLeft: '35px',
      listStyleType: 'disc',
    },
    linksListItem: {
      paddingLeft: '5px',
      marginBottom: '8px',
    },
    link: {
      color: 'var(--accents-primary-base-active)',
      fontSize: FontSizes.Size_5,
      lineHeight: '26px',
      cursor: 'pointer',

      '&:hover': {
        color: 'var(--accents-primary-base-action)',
      },
    },
  },
  {
    name: 'page-404',
  },
);

export default use404Styles;
